var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c;
import { css, html, LitElement } from "lit";
import { customElement, property, query } from "lit/decorators.js";
import { DefaultFftSize, DefaultMaxDecibels, DefaultMinDecibels, } from "./constants.js";
import { RrScope } from "./scope.js";
import { RrWaterfall } from "./waterfall.js";
import { Zoom, DefaultZoom } from "../coordinates/zoom.js";
import "./decibel-range.js";
import "./highlight.js";
import "./scope.js";
import "./scrollbar.js";
import "./waterfall.js";
import "./zoombar.js";
let RrSpectrum = class RrSpectrum extends LitElement {
    constructor() {
        super(...arguments);
        this.centerFrequency = 0;
        this.frequencyScale = 1;
        this.minDecibels = DefaultMinDecibels;
        this.maxDecibels = DefaultMaxDecibels;
        this.fftSize = DefaultFftSize;
        this.zoom = DefaultZoom;
        this.highlightDraggablePoint = false;
        this.highlightDraggableLeft = false;
        this.highlightDraggableRight = false;
        this.waterfallDraggable = false;
    }
    static get styles() {
        return [
            css `
        :host {
          display: flex;
          flex-direction: column;
          box-sizing: border-box;
          background: black;
          position: relative;

          --top-caption-margin: 16px;
          --left-caption-margin: 24px;
        }

        #view {
          display: flex;
          flex-direction: column;
          flex: 1;
          position: relative;
        }

        #controls {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
        }

        #controls rr-decibel-range {
          flex: 1;
          max-width: 100%;
        }

        #zoomControls {
          display: flex;
          flex-direction: row;
          flex: 10;
        }

        #zoomControls rr-scrollbar {
          min-width: 300px;
        }

        @media (max-width: 415px) {
          #zoomControls rr-scrollbar {
            min-width: 260px;
          }
        }

        .box {
          position: relative;
          width: 100%;
          height: 0;
        }

        .box > * {
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
        }

        #scopeBox {
          flex: 1;
          max-height: 150px;
        }

        #waterfallBox {
          flex: 2;
        }

        #waterfallBox > * {
          margin-left: var(--left-caption-margin);
        }

        #highlight {
          position: absolute;
          left: var(--left-caption-margin);
          top: var(--top-caption-margin);
          right: 0;
          bottom: 0;
        }
      `,
        ];
    }
    render() {
        return html `<div id="view">
        <div id="scopeBox" class="box">
          <rr-scope
            id="scope"
            .minDecibels=${this.minDecibels}
            .maxDecibels=${this.maxDecibels}
            .centerFrequency=${this.centerFrequency}
            .bandwidth=${this.bandwidth}
            .frequencyScale=${this.frequencyScale}
            .fftSize=${this.fftSize}
            .zoom=${this.zoom}
          ></rr-scope>
        </div>
        <div id="waterfallBox" class="box">
          <rr-waterfall
            id="waterfall"
            .minDecibels=${this.minDecibels}
            .maxDecibels=${this.maxDecibels}
            .bandwidth=${this.bandwidth}
            .fftSize=${this.fftSize}
            .zoom=${this.zoom}
            .draggable=${this.waterfallDraggable}
          ></rr-waterfall>
        </div>
        <rr-highlight
          id="highlight"
          .selection=${this.highlight}
          .draggableLeft=${this.highlightDraggableLeft}
          .draggableRight=${this.highlightDraggableRight}
          .draggablePoint=${this.highlightDraggablePoint}
          .fftSize=${this.fftSize}
          .zoom=${this.zoom}
        ></rr-highlight>
      </div>
      <div id="controls">
        <rr-decibel-range
          .minDecibels=${this.minDecibels}
          .maxDecibels=${this.maxDecibels}
          @spectrum-decibel-range-changed=${this.onDecibelRangeChanged}
        ></rr-decibel-range>
        <div id="zoomControls">
          <rr-zoombar
            .zoom=${this.zoom}
            .highlight=${this.highlight}
            @spectrum-zoom=${this.onZoom}
          ></rr-zoombar>
          <rr-scrollbar
            .zoom=${this.zoom}
            @spectrum-zoom=${this.onZoom}
          ></rr-scrollbar>
        </div>
      </div>`;
    }
    addFloatSpectrum(frequency, spectrum) {
        if (this.fftSize != spectrum.length) {
            this.fftSize = spectrum.length;
        }
        this.scope?.addFloatSpectrum(spectrum);
        this.waterfall?.addFloatSpectrum(frequency, spectrum);
    }
    onZoom(e) {
        this.zoom = e.detail;
    }
    onDecibelRangeChanged(e) {
        if (e.detail.min !== undefined) {
            this.minDecibels = e.detail.min;
        }
        if (e.detail.max !== undefined) {
            this.maxDecibels = e.detail.max;
        }
    }
};
__decorate([
    property({ type: Number, reflect: true }),
    __metadata("design:type", Number)
], RrSpectrum.prototype, "bandwidth", void 0);
__decorate([
    property({ type: Number, reflect: true, attribute: "center-frequency" }),
    __metadata("design:type", Number)
], RrSpectrum.prototype, "centerFrequency", void 0);
__decorate([
    property({ type: Number, reflect: true, attribute: "frequency-scale" }),
    __metadata("design:type", Number)
], RrSpectrum.prototype, "frequencyScale", void 0);
__decorate([
    property({ type: Number, reflect: true, attribute: "min-decibels" }),
    __metadata("design:type", Number)
], RrSpectrum.prototype, "minDecibels", void 0);
__decorate([
    property({ type: Number, reflect: true, attribute: "max-decibels" }),
    __metadata("design:type", Number)
], RrSpectrum.prototype, "maxDecibels", void 0);
__decorate([
    property({ type: Number, reflect: true }),
    __metadata("design:type", Number)
], RrSpectrum.prototype, "fftSize", void 0);
__decorate([
    property({ attribute: false }),
    __metadata("design:type", typeof (_a = typeof Zoom !== "undefined" && Zoom) === "function" ? _a : Object)
], RrSpectrum.prototype, "zoom", void 0);
__decorate([
    property({ attribute: false }),
    __metadata("design:type", Object)
], RrSpectrum.prototype, "highlight", void 0);
__decorate([
    property({ attribute: false }),
    __metadata("design:type", Boolean)
], RrSpectrum.prototype, "highlightDraggablePoint", void 0);
__decorate([
    property({ attribute: false }),
    __metadata("design:type", Boolean)
], RrSpectrum.prototype, "highlightDraggableLeft", void 0);
__decorate([
    property({ attribute: false }),
    __metadata("design:type", Boolean)
], RrSpectrum.prototype, "highlightDraggableRight", void 0);
__decorate([
    property({ attribute: false }),
    __metadata("design:type", Boolean)
], RrSpectrum.prototype, "waterfallDraggable", void 0);
__decorate([
    query("#scope"),
    __metadata("design:type", typeof (_b = typeof RrScope !== "undefined" && RrScope) === "function" ? _b : Object)
], RrSpectrum.prototype, "scope", void 0);
__decorate([
    query("#waterfall"),
    __metadata("design:type", typeof (_c = typeof RrWaterfall !== "undefined" && RrWaterfall) === "function" ? _c : Object)
], RrSpectrum.prototype, "waterfall", void 0);
RrSpectrum = __decorate([
    customElement("rr-spectrum")
], RrSpectrum);
export { RrSpectrum };
